import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import { Language } from '../../../../../../../common/constants/language';
import { LoadDataFacade, SetInitialStateFacade } from '../../../../../../../common';
import {
  UliItemAttachmentsDownloadPdf,
  UliItemAttachmentsGetAttachments,
  UliItemAttachmentsSetInitialState,
} from './uli-item-attachments.actions';
import { combineLatest, Observable } from 'rxjs';
import { CombinedAttachmentsModel, UliAttachmentsModel } from '../../../models/allocation-view-uli-item.model';
import { UliItemActionParams } from '../../models/uli-item-overview.model';
import { UliItemAttachmentsState } from './uli-item-attachments.state';
import { UliItemFacade } from '../uli-item.facade';
import { filter, take } from 'rxjs/operators';
import { HubItemFacade } from '../../../../../administration';
import { AppFacade } from '../../../../../app';

@Injectable({ providedIn: 'root' })
export class UliItemAttachmentsFacade implements SetInitialStateFacade, LoadDataFacade {
  attachments$: Observable<CombinedAttachmentsModel> = this.store.select(UliItemAttachmentsState.getAttachments);
  loaded$: Observable<boolean> = this.store.select(UliItemAttachmentsState.getLoaded);

  constructor(
    private store: Store,
    private uliItemFacade: UliItemFacade,
    private hubItemFacade: HubItemFacade,
    private appFacade: AppFacade,
  ) {}

  loadAll(): void {
    combineLatest([this.uliItemFacade.uliIdentifiers$, this.hubItemFacade.hubId$, this.appFacade.currentLanguage$])
      .pipe(
        filter(
          ([params, hubId, languageCode]: [UliItemActionParams, number, Language]) =>
            Boolean(params) && Boolean(hubId) && Boolean(languageCode),
        ),
        take(1),
      )
      .subscribe(([params, hubId, languageCode]: [UliItemActionParams, number, Language]) => {
        this.store.dispatch(
          new UliItemAttachmentsGetAttachments({
            params,
            hubId,
            languageCode,
          }),
        );
      });
  }

  downloadPDF(attachment: UliAttachmentsModel): void {
    this.store.dispatch(new UliItemAttachmentsDownloadPdf(attachment));
  }

  setInitialState(): void {
    this.store.dispatch(new UliItemAttachmentsSetInitialState());
  }
}
